
import Vue from 'vue'
import Component, { mixins } from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import firebase from 'firebase'
import { db, storageRef } from '@/main'
import mixin from '../../mixin'
//import colombiaCities from '@/models/colombia.ts'
import axios from 'axios'
import { URL_CLOUD_FUNCTIONS } from '@/firebase/init'
/* eslint @typescript-eslint/no-var-requires: "off" */
import * as cors from "cors";
const corsHandler = cors({ origin: true });
//import { URL_CLOUD_FUNCTIONS, KEY_MESSAGES, TOKEN_PUSH } from '@/firebase/init'

@Component
export default class DialogAddDiscount extends mixins(mixin) {
  @Prop() UID;
  @Prop() user;
  selectedPromotionCode = {}
  newUser = {
    names: '',
    last_names: '',
    genre: 'Masculino',
    birthday: '',
    email: '',
    country: 'Colombia',
    state: 'Santander',
    city: 'Bucaramanga',
    image: '',
    occupation: '',
    premium: false,
    creation_date: '',
  }
  defaultUser = {
    names: '',
    last_names: '',
    genre: 'Masculino',
    birthday: '',
    email: '',
    country: 'Colombia',
    state: 'Santander',
    city: 'Bucaramanga',
    image: '',
    occupation: '',
    premium: false,
    creation_date: '',
  }
  openRangeModal = false
  closeRangeModal = false
  openRange = ''
  closeRange = ''
  departments: any[] = []
  cities: any[] = []
  center = { lat: 9.929405, lng: -84.091424 }
  markerPosition = { lat: 9.929405, lng: -84.091424 }
  names = ''

  dialogAddDiscount = false
  nameRules = [
    (v) => (v != undefined ? !!v || 'Los nombres son obligatorios' : ''),
    (v) =>
      v != undefined
        ? v.length > 2 || 'Los nombres deben tener mas de 2 caracteres'
        : '',
  ]
  lastNameRules = [
    (v) => (v != undefined ? !!v || 'Los apellidos son obligatorios' : ''),
    (v) =>
      v != undefined
        ? v.length > 2 || 'Los apellidos deben tener mas de 2 caracteres'
        : '',
  ]
  emailRules = [
    (v) => !!v || 'El E-mail es obligatorio',
    (v) => /.+@.+\..+/.test(v) || 'El E-mail debe ser válido',
  ]
  phoneRules = [
    (v) => (v != undefined ? !!v || 'El teléfono es obligatorio' : ''),
    (v) =>
      v != undefined
        ? v.length === 7 || 'El teléfono debe tener 7 números'
        : '',
  ]
  cellphoneRules = [
    (v) => (v != undefined ? !!v || 'El celular es obligatorio' : ''),
    (v) =>
      v != undefined
        ? v.length === 10 || 'El celular debe tener 10 números'
        : '',
  ]
  selectedImage: File = new File([''], '')
  mounted() {
    // colombiaCities.forEach((value) => {
    //   this.departments.push(value.departamento)
    // })
    console.log(this.UID)
  }

  @Watch("selectedPromotionCode")
  onSelectedPromotionCodeChange(val){
    console.log(val)
  }
  @Watch('newUser.department')
  onNewUserDepartmentChange(val) {
    this.cities = []
    // colombiaCities.forEach((value) => {
    //   if (value.departamento === val) {
    //     for (const data of value.ciudades) {
    //       this.cities.push(data)
    //     }
    //   }
    // })
  }

  updateCenter(center) {
    console.log(center)
    this.center = {
      lat: center.lat,
      lng: center.lng,
    }
    this.markerPosition = this.center
  }

  openDialogAddDiscount() {
    this.dialogAddDiscount = true
  }

  onSelectedImageChange(val) {
    console.log(val)
    this.selectedImage = val
  }

  async addDiscount() {
    this.showNotification(
      'loading',
      'Creando descuento',
      'Un momento por favor'
    )
    const data = {
      uid: this.UID,
      subscriptionID: this.user.suscriptionID,
      promotionCodeID: this.selectedPromotionCode['id'],
      promotionCodeData: this.selectedPromotionCode
    }
    console.log(data)
    const url = URL_CLOUD_FUNCTIONS + 'updateSuscription'
    try {

      const res = await axios.post(url, data)
      console.log(res)
      this.showNotification('success', 'Éxito', 'descuento Creado')
      this.dialogAddDiscount = false
      if (this.$refs.formAddDiscount) {
        (this.$refs.formAddDiscount as any).reset()
      }
      return res
    } catch (error) {
      console.log(error)
      this.showNotification(
        'fail',
        'Error',
        'OCurrió un error al crear el descuento'
      )
    }
  }
}
